import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import ElementPlus from "element-plus";
import i18n from "./i18n";
import "element-plus/dist/index.css";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import "element-plus/theme-chalk/display.css";
import axios from "./gateway/backendapi";
import NProgress from "nprogress";
import Toaster from "@meforma/vue-toaster";
import clickOutside from "@/directives/clickOutside";
import "../public/remove-old-sw.js";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";

import "element-plus/theme-chalk/dark/css-vars.css";

const VueTelInputOptions = {
  mode: "international",
  dropdownOptions: {
    showSearchBox: true,
    showDialCodeInSelection: true,
    disabled: false,
  },
};

import PrimeVue from "primevue/config";
import Toast from "primevue/toast";
import Skeleton from "primevue/skeleton";
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import ConfirmDialog from "primevue/confirmdialog";
import OverlayPanel from "primevue/overlaypanel";
import SplitButton from "primevue/splitbutton";
import Checkbox from "primevue/checkbox";
import Tag from "primevue/tag";
import SelectButton from "primevue/selectbutton";
import ToastService from "primevue/toastservice";
import ConfirmationService from "primevue/confirmationservice";
import "primevue/resources/themes/saga-blue/theme.css"; //theme
import "primevue/resources/primevue.min.css"; //core css
import "primeicons/primeicons.css"; //icons

import VueGtag from "vue-gtag-next";
import VueLazyloadNext from "vue-lazyload-next";
import loadimage from "./assets/loading.gif";
import errorimage from "./assets/file-not-found.png";
import getSubdomain from "./services/churchTypeMiddlware";
import AOS from "aos";
import "aos/dist/aos.css";

AOS.init({
  duration: 1000, // You can customize the options here
});

NProgress.configure({ showSpinner: false });
axios.interceptors.request.use((config) => {
  if (typeof window === "undefined") return config;
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // config.headers.Authorization = `Bearer ${process.env.VUE_APP_PAYSTACK_SECRET_KEY}`
  /*eslint no-undef: "warn"*/
  NProgress.start();
  return config;
});

// before a response is returned stop nprogress
axios.interceptors.response.use(
  (response) => {
    NProgress.done();
    return response;
  },
  (error) => {
    console.log(error, "there is the error path");
    NProgress.done();
    if (error && error.response && error.response.status == 403) {
      router.push("/errorpage/unauthorized");
    } else {
      return Promise.reject(error);
    }
  }
);

const app = createApp(App);

app.use(VueGtag, {
  property: {
    id: "G-YNZ7GTSYZV",
    // id: "UA-123456-7"
  },
});

app.use(VueLazyloadNext, {
  preLoad: 1.3,
  error: errorimage,
  loading: loadimage,
  attempt: 1,
});
app.component("Toast", Toast);
app.component("Skeleton", Skeleton);
app.component("Dialog", Dialog);
app.component("Button", Button);
app.component("OverlayPanel", OverlayPanel);
app.component("SelectButton", SelectButton);
app.component("ConfirmDialog", ConfirmDialog);
app.component("SplitButton", SplitButton);
app.component("Checkbox", Checkbox);
app.component("Tag", Tag);
app.directive("click-outside", clickOutside);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.provide(
  "primarycolor",
  getSubdomain() === "alatfaith" ? "#971931" : "#0040ff"
);

app.config.globalProperties.$aos = AOS;

app
  .use(store)
  .use(router)
  .use(i18n())
  .use(Toaster)
  .use(PrimeVue)
  .use(ToastService)
  .use(ConfirmationService)
  .use(ElementPlus)
  .use(VueTelInput, VueTelInputOptions)
  .mount("#app");

// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker.getRegistrations().then((regs) => {
//     regs.forEach((reg) => {
//       reg.unregister().then(() => {
//         if (navigator.serviceWorker.controller) {
//           navigator.serviceWorker.controller.postMessage({
//             action: "skipWaiting",
//           });
//         }
//       });
//     });
//   });

//   // Clear stale caches
//   caches.keys().then((keys) => {
//     keys.forEach((key) => caches.delete(key));
//   });
// }
